import { render, staticRenderFns } from "./QuotaSummaryResource.vue?vue&type=template&id=739a2fc6&scoped=true&"
import script from "./QuotaSummaryResource.vue?vue&type=script&lang=js&"
export * from "./QuotaSummaryResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739a2fc6",
  null
  
)

export default component.exports